import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { MatDialogModule } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { TranslateModule } from "@ngx-translate/core";
import { MatToolbarModule } from "@angular/material/toolbar";
import { FuseSharedModule } from "@fuse/shared.module";
import { PagoComponent } from "./detalle-contratista/components/pago/pago.component";
import { MatTabsModule } from "@angular/material/tabs";
import { MatListModule } from "@angular/material/list";
import { MatTableModule } from "@angular/material/table";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatSortModule } from "@angular/material/sort";
import { TablaContratistasComponent } from "./contratistas/components/tabla-contratistas/tabla-contratistas.component";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { DetalleContratistaComponent } from "./detalle-contratista/detalle-contratista.component";
import { ContratistasComponent } from "./contratistas/contratistas.component";
import { DisponibilidadComponent } from "./detalle-contratista/components/disponibilidad/disponibilidad.component";
import { IdentificacionComponent } from "./detalle-contratista/components/identificacion/identificacion.component";
import { CertificacionesComponent } from "./detalle-contratista/components/certificaciones/certificaciones.component";
import { EspecialidadesComponent } from "./detalle-contratista/components/especialidades/especialidades.component";
import { AuthGuard } from "@auth0/auth0-angular";
import { RoleGuardService } from "../../shared/services/auth/role-guard.service";
import { SharedModule } from "../../shared/shared/shared.module";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { DialogContratistaComponent } from "./contratistas/components/dialog-contratista/dialog-contratista.component";
import { MatSelectModule } from "@angular/material/select";
import { DialogZonasCoberturaComponent } from "./detalle-contratista/components/dialog-zonas-cobertura/dialog-zonas-cobertura.component";
import { DialogEspecialidadesComponent } from "./detalle-contratista/components/dialog-especialidades/dialog-especialidades.component";
import { FiltroContratistasComponent } from "./contratistas/components/filtro-contratistas/filtro-contratistas.component";
import { MatSliderModule } from "@angular/material/slider";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatChipsModule } from "@angular/material/chips";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { EspecialidadesSolicitadasComponent } from './detalle-contratista/components/especialidades-solicitadas/especialidades-solicitadas.component';
import { HorariosComponent } from './detalle-contratista/components/horarios/horarios.component';
import { DialogDocumentosComponent } from './detalle-contratista/components/certificaciones/dialog-documentos/dialog-documentos.component';
import { MatDatepickerModule } from "@angular/material/datepicker";
import { DialogDocumentosPersonalApoyoComponent } from './detalle-contratista/components/dialog-documentos-personal-apoyo/dialog-documentos-personal-apoyo.component';
import { IdentificacionPersonalApoyoComponent } from './detalle-contratista/components/identificacion-personal-apoyo/identificacion-personal-apoyo.component';

const routes = [
    {
        path: "contratistas",
        component: ContratistasComponent,
        canActivate: [AuthGuard, RoleGuardService],
        data: {
            allowedRoles: [1],
        },
    },
    {
        path: "contratistas/:rutContratista",
        component: DetalleContratistaComponent,
        canActivate: [AuthGuard, RoleGuardService],
        data: {
            allowedRoles: [1],
        },
    },
];

@NgModule({
    declarations: [
        ContratistasComponent,
        DetalleContratistaComponent,
        IdentificacionComponent,
        EspecialidadesComponent,
        CertificacionesComponent,
        PagoComponent,
        DisponibilidadComponent,
        TablaContratistasComponent,
        DialogContratistaComponent,
        DialogZonasCoberturaComponent,
        DialogEspecialidadesComponent,
        FiltroContratistasComponent,
        EspecialidadesSolicitadasComponent,
        HorariosComponent,
        DialogDocumentosComponent,
        DialogDocumentosPersonalApoyoComponent,
        IdentificacionPersonalApoyoComponent
    ],
    imports: [
        RouterModule.forChild(routes),
        CommonModule,
        MatDialogModule,
        MatIconModule,
        MatButtonModule,
        TranslateModule,
        MatToolbarModule,
        FuseSharedModule,
        MatTabsModule,
        MatListModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        MatFormFieldModule,
        MatInputModule,
        SharedModule,
        MatSlideToggleModule,
        MatSelectModule,
        MatSliderModule,
        MatButtonToggleModule,
        MatChipsModule,
        MatAutocompleteModule,
        MatCheckboxModule,
        MatDatepickerModule
    ],
    entryComponents: [DetalleContratistaComponent],
})
export class ContratistaModule {}

